<cdk-virtual-scroll-viewport #viewport itemSize="15" class="h-100" [appCdkScrollStickyTh]="viewport">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <tr>
                <th>Kundenr</th>
                <th>Navn</th>
                <th>Accfra</th>
                <th>acctype</th>
                <th>accbelob</th>
                <th>A Fak i {{ acontoDate | date:'MM-yy' }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *cdkVirtualFor="let acontoClient of acontoClients; trackBy:trackByFnr">
                <td>{{ acontoClient.glkundenr }}</td>
                <td>{{ acontoClient.navn1 }}</td>
                <td>{{ acontoClient.accfra | date:'MM-yy' }}</td>
                <td>{{ acontoClient.acctype | acontoType }}</td>
                <td>{{ acontoClient.accbelob }}</td>
                <td>{{ acontoClient.accfaktureret }}</td>
            </tr>
        </tbody>
    </table>
</cdk-virtual-scroll-viewport>
